module.exports = __webpack_public_path__ + "img/lock-open.47a25d43.svg";